import React from 'react';
import styled from "@emotion/styled";
import { Inner, Wrap } from 'styles/structure';
import { Rubric } from 'styles/typography';
import colors from "styles/colors";
import dimensions from 'styles/dimensions';
import Illustration from 'components/_ui/Illustration';
import Content from 'components/_ui/Content';
import Drawer from 'components/Drawer';
import Button from 'components/_ui/Button';

const AccordionContainer = styled.div`
  background-color: ${colors.orange100};
  padding: 5.6rem 0;
  margin-top: 6.4rem;
  
  & + * {
    margin-top: 6.4rem;
  }
  
  &:last-of-type {
    margin-bottom: 0 !important;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 10.4rem 0 12rem;
    margin-top: 12rem;
    
    & + * {
      margin-top: 12rem;
    }
`;

const AccordionHeader = styled.div`
  text-align: center;
  margin-bottom: 6.4rem;
    
  h4 {
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    align-items: center;
    text-align: left;
    margin-bottom: 9.6rem;
    
    h4 {
      & + * {
        margin-top: 2.4rem;
      }
    }
  }
`;

const AccordionImage = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  
  img {
    display: block;
    width: 100%;
  }
  
  & + * {
    margin-top: 4rem;
  }
    
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 50%;
    margin-right: 5.6vw;
    max-width: none;
  }
`;

const AccordionContent = styled.div`
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 50%;
  }
`;

const AccordionDrawers = styled.div``;

const AccordionButtons = styled.div`
  width: 100%;
  margin-top: 5.6rem;
  
  > * {
    width: 100%;
    
    & + * {
      margin-top: 2.4rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletPortraitUp}px) {
    > * {
      width: auto;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    justify-content: center;
    margin-top: 10.4rem;
    
    > * {
      & + * {
        margin-top: 0;
        margin-left: 2rem;
      }
    }
  }
`;

const Accordion = ({ intro, heading, content, image, illustration, buttonText, buttonDestination, items }) => {
  return (
    <AccordionContainer>
      <Inner>
        {(heading || content) && (
          <AccordionHeader>
            {(image || illustration) && (
              <AccordionImage>
                {illustration && (
                  <Illustration source={illustration}/>
                )}

                {(!illustration && image) && (
                  <img src={image.url} alt={image.alt} loading="lazy" />
                )}
              </AccordionImage>
            )}

            <AccordionContent>
              {intro && <Rubric>{intro}</Rubric>}
              {heading && <h4>{heading}</h4>}
              {content && <Content content={content}/>}
            </AccordionContent>
          </AccordionHeader>
        )}

        <AccordionDrawers>
          <Wrap>
            {items.map((item, i) => (
              <Drawer
                key={i}
                image={item.image}
                illustration={item.illustration}
                heading={item.heading}
                content={item.content}
              />
            ))}
          </Wrap>
        </AccordionDrawers>

        {(buttonText && buttonDestination) && (
          <AccordionButtons>
            <Button
              as='a'
              href={buttonDestination}
            >
              <span>{buttonText}</span>
            </Button>
          </AccordionButtons>
        )}
      </Inner>
    </AccordionContainer>
  );
};

export default Accordion;
